export const onCellEditComplete = (e) => {
  const { rowData, newValue, field, originalEvent: event } = e
  if (newValue !== null) rowData[field] = newValue
  else event.preventDefault()
}
